import { Suspense } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { listProductLibAppIAM } from "../../graphql/queries";
import { RiUserSettingsLine } from "react-icons/ri";
import Table from "./table";
import Waiting from "../../components/Waiting";
import wrapPromise from "../../helpers/wrapPromise";
import { extractPermissions } from "../../helpers/extract";

function UserPermissions() {
  const fetchPermissionData = () => {
    const permissions: any = API.graphql(
      graphqlOperation(listProductLibAppIAM, { limit: 600 })
    );

    return {
      permissions: wrapPromise(permissions),
    };
  };

  const ps = fetchPermissionData();

  const ShowPermissionList = ({ ps }: any) => {
    const permissions = ps.permissions.read();
    const permissionItems = extractPermissions(permissions);

    return (
      <>
        <div className="p-4">
          <Table
            data={permissionItems.sort((n1, n2) => {
              if (n1.updatedAt > n2.updatedAt) {
                return 1;
              }

              if (n1.updatedAt > n2.updatedAt) {
                return -1;
              }

              return 0;
            })}
          />
        </div>
      </>
    );
  };

  return (
    <>
      <div>
        <ul
          className="flex flex-col flex-wrap justify-center pl-0 mt-2 mb-1 list-none border-b-0 md:flex-row"
          role="tablist"
          data-te-nav-ref
        >
          <li role="presentation">
            <a
              href="#tabs-sync-product"
              className="my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 pt-4 pb-3.5 text-xs font-medium uppercase leading-tight text-neutral-600 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate focus:border-transparent data-[te-nav-active]:border-violet data-[te-nav-active]:text-violet dark:text-neutral-600 dark:hover:bg-transparent data-[te-nav-active]:border-neutral-600 data-[te-nav-active]:text-neutral-600"
              data-te-toggle="pill"
              data-te-target="#tabs-sync-product"
              data-te-nav-active
              role="tab"
              aria-controls="tabs-sync-product"
              aria-selected="true"
            >
              <div className="flex items-center gap-2">
                <RiUserSettingsLine size={25} />
                <span className="">User Permissions</span>
              </div>
            </a>
          </li>
        </ul>
        <div>
          <Suspense fallback={<Waiting />}>
            <ShowPermissionList ps={ps} />
          </Suspense>
        </div>
      </div>
    </>
  );
}
export default UserPermissions;
